"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const ecommerce_1 = require("../../../api/ecommerce");
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const GlobalModal_1 = require("../../../common/js/components/GlobalModal");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const Select_1 = __importDefault(require("../../atoms/Select"));
const Paths_1 = require("../../constants/Paths");
const Categories_1 = __importDefault(require("../../enums/Categories"));
const history_1 = require("../../helper/history");
const sorting_1 = require("../../helper/sorting");
const ProductFilter_1 = __importDefault(require("../../stores/ProductFilter"));
const ShopwareCategories_1 = __importDefault(require("../../stores/ShopwareCategories"));
const ShopwareProducts_1 = __importDefault(require("../../stores/ShopwareProducts"));
const UiStore_1 = __importDefault(require("../../stores/UiStore"));
const ProductFilter_2 = __importDefault(require("../ProductFilter"));
const ProductFilterModal_1 = __importDefault(require("../ProductFilterModal"));
const ProductList_1 = __importDefault(require("../ProductList"));
class ShopCategory extends react_1.default.Component {
    onRefreshDeferredPrices;
    contextReactionDisposer;
    cachedProducts = new Map();
    isLoading = true;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            cachedProducts: mobx_1.observable,
            isLoading: mobx_1.observable,
            sortingPropertyKey: mobx_1.computed,
            categoryId: mobx_1.computed,
            products: mobx_1.computed,
            category: mobx_1.computed,
            sortableProperties: mobx_1.computed,
            sortableOptions: mobx_1.computed,
            isCategorySoftware: mobx_1.computed,
            loadProducts: mobx_1.action,
        });
    }
    get sortingPropertyKey() {
        return new URLSearchParams(this.props.location.search).get('sort') ?? ecommerce_1.ProductSearchRequestBodySortEnum.NameAsc;
    }
    get categoryId() {
        return this.props.match.params.category ?? null;
    }
    get products() {
        return Array.from(this.cachedProducts.values());
    }
    get category() {
        if (!this.categoryId) {
            return null;
        }
        return ShopwareCategories_1.default.getCategory(this.categoryId) ?? null;
    }
    get sortableProperties() {
        const defaultOptions = (0, sorting_1.defaultSortingProperties)();
        const sortableProperties = this.category?.extensions?.massiveCategory?.displayedProperties;
        const sortableProducts = this.products ?? [];
        let productOptions = [];
        if (sortableProperties && sortableProperties.length > 0) {
            productOptions = (0, sorting_1.productSortingProperties)(sortableProducts, sortableProperties);
        }
        return defaultOptions.concat(productOptions);
    }
    get sortableOptions() {
        return this.sortableProperties
            .map((p) => {
            return {
                key: p.key,
                position: p.position,
                name: p.name
                    ? p.name
                    : (0, translation_1.t)(`select.product_sort.direction.${p.direction}`, {
                        type: p.type,
                        property: (0, translation_1.t)(`select.product_sort.property.${p.property}`),
                    }),
            };
        })
            .sort((a, b) => a.position - b.position)
            .reduce((options, option) => {
            return {
                ...options,
                [option.key]: option.name,
            };
        }, {});
    }
    get isCategorySoftware() {
        return Categories_1.default.SOFTWARE === this.category?.extensions?.massiveCategory?.externalId;
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('shop_subpage_title', { title: this.category?.translated?.name });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => [
            AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.SHOP_READ),
            AuthorizationStore_1.default.auth0?.isLoading,
            this.categoryId,
            AuthorizationStore_1.default.customerId,
        ], ([hasAccess, authIsLoading, categoryId]) => {
            if (!authIsLoading && (!AuthorizationStore_1.default.auth0?.isAuthenticated || hasAccess) && categoryId) {
                this.loadProducts();
                this.reloadProducts();
            }
            else {
                this.onRefreshDeferredPrices?.();
                this.onRefreshDeferredPrices = undefined;
            }
        }, { fireImmediately: true });
    }
    componentDidUpdate() {
        document.title = (0, translation_1.t)('shop_subpage_title', { title: this.category?.translated?.name });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
        this.onRefreshDeferredPrices?.();
    }
    render() {
        const categoryHasFilters = (this.category?.extensions?.massiveCategory?.filterProperties?.length ?? 0) > 0;
        const filteredProducts = this.category && this.products ? ProductFilter_1.default.filterProducts(this.category, this.products) : [];
        if (ShopwareCategories_1.default.isLoading || !this.category) {
            return (react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-center vh-100" },
                react_1.default.createElement(LoadingSpinner_1.default, null)));
        }
        return (react_1.default.createElement("section", { className: "znd-shop-category-page" },
            react_1.default.createElement("div", { className: "znd-shop-category-page__content" },
                this.category && this.products.length > 0 && categoryHasFilters ? (react_1.default.createElement("div", { className: "znd-shop-category-page__sidebar" }, this.isLoading ? (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                    react_1.default.createElement(LoadingSpinner_1.default, { className: "znd-shop-category-page__sidebar-loader" }))) : (react_1.default.createElement(ProductFilter_2.default, { category: this.category, products: this.products, autoApply: true })))) : null,
                react_1.default.createElement("div", { className: "znd-shop-category-page__main" },
                    react_1.default.createElement("div", { className: "znd-header-page d-flex justify-content-between align-items-start flex-column align-items-sm-center flex-sm-row" },
                        react_1.default.createElement("div", { className: "znd-header-page-left" },
                            react_1.default.createElement("div", { className: "znd-header-page__title t-headline-2" }, this.category?.translated?.name),
                            react_1.default.createElement("div", { className: "znd-header-page__subtitle" }, (0, translation_1.t)('category_page.count_for_category', {
                                productCount: this.isLoading ? '…' : filteredProducts.length,
                                categoryName: this.category?.translated?.name,
                            }))),
                        this.isCategorySoftware || this.isLoading ? null : (react_1.default.createElement("div", { className: "znd-header-page-right" },
                            this.category && this.products.length > 0 && categoryHasFilters ? (react_1.default.createElement("div", { className: "znd-select-box-button mr-auto mr-sm-3 d-xl-none", onClick: this.showMobileFilterModal },
                                react_1.default.createElement(Icon_1.default, { className: "znd-select-box-button__icon", name: Zupicons_1.default.filter }),
                                (0, translation_1.t)('category_page.filter_button'))) : null,
                            react_1.default.createElement(Select_1.default, { label: (0, translation_1.t)('select.product_sort.description'), value: this.sortingPropertyKey, options: this.sortableOptions, onChange: (sort) => {
                                    const { pathname, search } = this.props.location;
                                    const params = new URLSearchParams(search);
                                    params.set('sort', sort);
                                    (0, history_1.pushHistory)(this.props.history, pathname + `?${params.toString()}`);
                                } })))),
                    react_1.default.createElement("div", { className: "znd-shop-category-page__product-list-wrapper" }, this.isLoading ? (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                        react_1.default.createElement(LoadingSpinner_1.default, null))) : (react_1.default.createElement(ProductList_1.default, { products: filteredProducts, sortingProperty: this.sortableProperties.find((p) => this.sortingPropertyKey === p.key), isCategorySoftware: this.isCategorySoftware })))))));
    }
    loadProducts() {
        const categoryId = this.categoryId;
        if (!categoryId) {
            (0, history_1.replaceHistory)(this.props.history, Paths_1.PATH_SHOP);
            return;
        }
        this.isLoading = true;
        this.cachedProducts.clear();
        ShopwareCategories_1.default.initialize()
            .then(() => ShopwareProducts_1.default.loadProductsForCategory(categoryId))
            .then((0, mobx_1.action)((products) => {
            products?.forEach((product) => {
                this.cachedProducts.set(product.id, product);
            });
        }))
            .finally((0, mobx_1.action)(() => {
            this.isLoading = false;
        }));
    }
    reloadProducts() {
        if (this.onRefreshDeferredPrices) {
            return;
        }
        this.onRefreshDeferredPrices = (0, mobx_1.reaction)(() => [UiStore_1.default.fiveSeconds], () => {
            if (this.isLoading) {
                return;
            }
            const pending = Array.from(this.cachedProducts.values())
                .filter((product) => product.extensions?.massiveDeferPriceDisplay?.defer ?? false)
                .map((product) => product.id);
            if (pending.length <= 0) {
                return;
            }
            ShopwareProducts_1.default.loadProducts(pending).then((products) => {
                products?.forEach((product) => {
                    if (this.cachedProducts.has(product.id)) {
                        this.cachedProducts.set(product.id, product);
                    }
                });
            });
        });
    }
    showMobileFilterModal() {
        if (!this.category) {
            return;
        }
        (0, GlobalModal_1.showModal)({
            component: ProductFilterModal_1.default,
            props: {
                category: this.category,
                products: this.products,
            },
        }).then(ProductFilter_1.default.applyFilter, ProductFilter_1.default.restoreFilter);
    }
}
__decorate([
    bind_decorator_1.default
], ShopCategory.prototype, "showMobileFilterModal", null);
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(ShopCategory));
